/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "./RenderFullPageLoading.css";
import PropTypes from "prop-types";

const RenderFullPageLoading = (props) => {
  let loadingStyle = {};
  if (props.loadingColor) {
    loadingStyle.background = "#" + props.loadingColor;
  }
  return (
    <div className="Loading-emptyPage">
      <div className="Loading-center">
        <div className="Loading-btm-load"></div>
      </div>
    </div>
  );
};

RenderFullPageLoading.propTypes = {
  loadingColor: PropTypes.string,
};

RenderFullPageLoading.defaultProps = {
  loadingColor: "2B91D6",
};

export default RenderFullPageLoading;
